<template>
  <div :style="containerStyle">
    <v-quagga
      :onDetected="onDetected"
      :readerSize="readerSize"
      :readerTypes="readerTypes"
      facingMode="environment"
    ></v-quagga>
  </div>
</template>
<script>
import Vue from 'vue';
import VueQuagga from 'vue-quaggajs';
import _ from 'lodash';
Vue.use(VueQuagga);

export default {
  name: 'BarcodeScanner',
  props: {
    width: {
      type: Number,
      default: 640,
    },
    height: {
      type: Number,
      default: 480,
    },
  },
  data() {
    return {
      readerTypes: [
        'ean_reader',

        'code_128_reader',
        //'ean_reader',
        //'ean_8_reader',
        'code_39_reader',
        // 'code_39_vin_reader',
        // 'codabar_reader',
        'upc_reader',
        // 'upc_e_reader',
        // 'i2of5_reader',
        // '2of5_reader',
        // 'code_93_reader',
      ],
      buffer: [],
      throttleEmitResult: _.throttle(this.emitResult, 1000, { leading: false }),
    };
  },
  computed: {
    containerStyle() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
      };
    },
    readerSize() {
      return {
        width: this.width,
        height: this.height,
      };
    },
  },
  methods: {
    getHighestFrequency(numbers) {
      const frequencyMap = _.countBy(numbers);
      const maxFrequency = _.max(_.values(frequencyMap));
      const highestFrequencyNumber = _.findKey(frequencyMap, value => value === maxFrequency);
      return highestFrequencyNumber;
    },
    onDetected(data) {
      if (!data?.codeResult?.code) return;
      const { code, format } = data.codeResult;
      this.buffer.push(code);
      this.throttleEmitResult();
      //this.$emit('onDetected', { code, format });
    },
    emitResult() {
      const highestFrequencyNumber = this.getHighestFrequency(this.buffer);
      this.$emit('onDetected', highestFrequencyNumber);
      this.buffer = [];
    },
  },
};
</script>
